import { render, staticRenderFns } from "./TagSelect.vue?vue&type=template&id=e5c249d8&scoped=true"
import script from "./TagSelect.vue?vue&type=script&lang=js"
export * from "./TagSelect.vue?vue&type=script&lang=js"
import style0 from "./TagSelect.vue?vue&type=style&index=0&id=e5c249d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c249d8",
  null
  
)

export default component.exports